var _tspan, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatentProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M77.66,246.71c-95.18,55-95.17,144,0,199s249.49,55,344.67,0,95.17-144,0-199S172.84,191.76,77.66,246.71Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.66,261.06c-6.78,11.5-20.1,16.3-27.57,46.18-1.19,4.79-2,9.18-2.65,13.08l-11.74-6.78c.05-12.17,1.51-27.88,6.95-43.48,6.4-18.32,18.23-26.9,25.54-27.78C459.4,241.28,467.8,249,460.66,261.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.51,249a.51.51,0,0,0-.72-.1c-12.4,9.36-27.87,35.81-27.62,68.13l.13.09-.13-.09h0c.34.23.69.45,1,.68-.48-32.27,14.91-58.7,27.22-68A.51.51,0,0,0,452.51,249Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.6,313.64a64.71,64.71,0,0,0-8.7,9.83l-10.41-6c3.67-17.43,14.41-28.11,20-31.45,7.56-4.51,18.34-6.28,20.43,1.82S454.44,304.41,444.6,313.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.61,285.9a.51.51,0,0,0-.66-.3c-8.14,3-23.46,18.78-29.29,34.56l.26.13c.23.11.46.24.68.36,5.73-15.42,20.92-31.22,28.7-34.09A.51.51,0,0,0,458.61,285.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.86,267.88l9.69-5.6s5.76-24,3.47-45.53c-3.24-30.32-23.19-41.73-30.78-39.11S70.45,189.07,83,207.13C90.42,217.79,99.52,240,97.86,267.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87,256.11h-.09a.68.68,0,0,1-.54-.79c5.32-28-4.45-59.39-16.55-72.47a.67.67,0,0,1,0-1,.68.68,0,0,1,1,0C98,195.24,108,227.18,102.56,255.56A.68.68,0,0,1,101.87,256.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,282c-1.45.74-5.3-2.56-6.38-3.36a13.44,13.44,0,0,1-4.2-5.35,12.56,12.56,0,0,1-.74-7.61,28.66,28.66,0,0,1,1.16-4l1.32-3.85a10,10,0,0,0,.77-3.9c-.21-2.69-2.48-4.68-4.56-6.4-2.29-1.9-4.65-4.38-4.47-7.59a11.25,11.25,0,0,1,3.17-6.58c1.63-1.87,3.54-3.49,5-5.48A7.85,7.85,0,0,0,66.44,223a8.28,8.28,0,0,0-.93-3.17c-1-2.15-2.43-4.14-3.1-6.42s-.41-5.08,1.42-6.6c1.51-1.24,3.66-1.32,5.6-1.09a12.86,12.86,0,0,1,5,2.06c5,3.1,7.56,9.28,12.86,11.74,2,.94,4.32,1.24,6.47,1.93s4.3,1.91,5.21,4c1.79,4.07-2.15,8.77-1,13.05,1,3.79,4.59,5.4,6.46,8.86a8,8,0,0,1,.7,4.92,23.45,23.45,0,0,1-2.47,8.14,72.8,72.8,0,0,1-4.89,7.53S73.69,281.85,73.47,282Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,274.65h0a.64.64,0,0,1-.59-.69c2.32-25.15-8.15-53.58-16.38-62.1a.64.64,0,0,1,.91-.89c8.4,8.7,19.09,37.6,16.74,63.1A.63.63,0,0,1,87.49,274.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,243.64l-.18,0c-8-2.91-18-3.86-18.14-3.87a.64.64,0,0,1-.58-.69.62.62,0,0,1,.69-.58c.1,0,10.33,1,18.46,3.95a.63.63,0,0,1-.25,1.23Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Patent--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "282.23 457.74 282.22 462.79 478.81 349.29 478.81 344.24 282.23 457.74",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.23 457.74 282.22 462.79 478.81 349.29 478.81 344.24 282.23 457.74",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.81 344.24 220.41 195.05 23.74 308.6 282.23 457.74 478.81 344.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41,196.26l256.31,148L282.23,456.53,25.84,308.6,220.41,196.26m0-1.21L23.74,308.6,282.23,457.74l196.58-113.5L220.41,195.05Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.23 457.74 23.74 308.6 23.74 313.51 282.22 462.79 282.23 457.84 282.23 457.74",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.63,280.84,55.71,307.93c-1.16.67-1.21,1.72-.13,2.35a4.51,4.51,0,0,0,4.06-.08l46.92-27.09c1.16-.67,1.22-1.72.13-2.34A4.48,4.48,0,0,0,102.63,280.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36,289.92,71.44,317c-1.16.67-1.22,1.72-.13,2.35a4.51,4.51,0,0,0,4.06-.08l46.92-27.09c1.16-.67,1.22-1.72.13-2.34A4.47,4.47,0,0,0,118.36,289.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,295.52l-29.36,17c-1.15.67-1.21,1.72-.13,2.35a4.53,4.53,0,0,0,4.07-.08l29.35-16.95c1.16-.67,1.22-1.72.13-2.34A4.48,4.48,0,0,0,92.93,295.52Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.88,237.65,90.55,326.18c-1.16.67-1.22,1.72-.13,2.35a4.48,4.48,0,0,0,4.06-.08l153.33-88.52c1.16-.67,1.22-1.72.13-2.35A4.51,4.51,0,0,0,243.88,237.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,242.19,98.41,330.72c-1.16.67-1.22,1.72-.13,2.35a4.48,4.48,0,0,0,4.06-.08l153.34-88.52c1.15-.67,1.21-1.72.13-2.35A4.53,4.53,0,0,0,251.74,242.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,246.73,106.27,335.26c-1.15.67-1.21,1.72-.13,2.35a4.51,4.51,0,0,0,4.06-.08L263.54,249c1.16-.66,1.22-1.71.13-2.34A4.51,4.51,0,0,0,259.61,246.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47,251.27,114.14,339.8c-1.16.67-1.22,1.72-.13,2.35a4.48,4.48,0,0,0,4.06-.08L271.4,253.55c1.16-.67,1.22-1.72.13-2.35A4.51,4.51,0,0,0,267.47,251.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.35,260.44,130,349c-1.16.67-1.22,1.72-.13,2.34a4.47,4.47,0,0,0,4.06-.07l153.34-88.53c1.15-.67,1.21-1.72.13-2.35A4.51,4.51,0,0,0,283.35,260.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21,265,137.87,353.51c-1.15.67-1.21,1.72-.13,2.34a4.5,4.5,0,0,0,4.07-.07l153.33-88.53c1.16-.67,1.22-1.72.13-2.35A4.51,4.51,0,0,0,291.21,265Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,269.52,145.74,358.05c-1.16.67-1.22,1.72-.13,2.34a4.48,4.48,0,0,0,4.06-.07L303,271.79c1.16-.67,1.22-1.72.13-2.35A4.51,4.51,0,0,0,299.07,269.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,274.06,153.6,362.59c-1.16.67-1.22,1.72-.13,2.34a4.47,4.47,0,0,0,4.06-.07l153.34-88.53c1.15-.67,1.21-1.72.13-2.35A4.51,4.51,0,0,0,306.94,274.06Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.81,283.22,169.47,371.75c-1.15.67-1.21,1.72-.13,2.35a4.53,4.53,0,0,0,4.07-.08l153.33-88.53c1.16-.66,1.22-1.71.13-2.34A4.51,4.51,0,0,0,322.81,283.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.67,287.76,177.34,376.29c-1.16.67-1.22,1.72-.13,2.35a4.51,4.51,0,0,0,4.06-.08L334.61,290c1.15-.66,1.21-1.71.12-2.34A4.51,4.51,0,0,0,330.67,287.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47,333.32l-82.2,47.42c-1.16.67-1.22,1.72-.13,2.35a4.48,4.48,0,0,0,4.06-.08l82.2-47.42c1.16-.67,1.22-1.72.13-2.35A4.51,4.51,0,0,0,267.47,333.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,372.78l69.76-40.27c.75-.44.78-1.11.09-1.51a2.88,2.88,0,0,0-2.62,0L351,371.32c-.74.43-.78,1.1-.08,1.5A2.86,2.86,0,0,0,353.48,372.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.42,369.85l52.91-30.52c.75-.43.78-1.11.09-1.51a2.92,2.92,0,0,0-2.62.05l-52.91,30.52c-.74.43-.78,1.11-.08,1.51A2.86,2.86,0,0,0,348.42,369.85Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.17,322.83c-.18.07-.31.2-.29.33a43.3,43.3,0,0,0,3.95,13.73c-1.19.3-2.73.25-3.46-.44-.21-.2-1-.22-1.08.07s-.12.59-.19.88l-2-1.22c-.26-.15-1.06-.11-1,.17l.51,2.44a10.55,10.55,0,0,1-2.19-1.59c-.27-.26-1.2-.17-1,.17a4.08,4.08,0,0,1,.34,2.69,32.61,32.61,0,0,1-3.33-2.87c-.2-.21-1.14-.2-1.05.11a14.39,14.39,0,0,1,.53,2.8c0,.41,0,.83,0,1.24s.1,1-.32,1.38c-.64.57-1.38-.44-1.64-.73a6.26,6.26,0,0,1-.56-.74,22.58,22.58,0,0,0-1.18-2.92h0s0,0,0-.06c-.14-.27-1.11-.16-1.08.12a6.71,6.71,0,0,0,1.21,3,19.64,19.64,0,0,1,.82,3.81c-1.07.74-2.17,1.49-3.27,2.23a1.09,1.09,0,0,0-.08-.15c-.3-.6-.56-1.21-.8-1.83a9.65,9.65,0,0,0,.65-2.9,10.15,10.15,0,0,0-1.6-5.88,12.35,12.35,0,0,0,.48-2.39,8.49,8.49,0,0,0-1.18-5.1,7.62,7.62,0,0,0-5.8-3.86c-5.91-.84-10.74,2.4-11.54,5.49-1,3.72,2.15,7.47,4.47,10.83,1.26,1.84,2.56,3.67,3.76,5.52a42.82,42.82,0,0,1-6.08,3.62,44.26,44.26,0,0,1-4.24,1.8c-.38.14.31.35.61.25a47,47,0,0,0,10.14-5,44.24,44.24,0,0,1,3.1,5.6c-3.39,2.94-5.89,6.12-6.19,9.82A7.64,7.64,0,0,0,345.7,368c.49.78,2.26,3.48,4.42,2.49a2.53,2.53,0,0,0,1-1,11.46,11.46,0,0,0,.86-1.28,13,13,0,0,0,1.14-2.43,13.64,13.64,0,0,0,.74-5.27,19.8,19.8,0,0,0-1.81-7.1,76.4,76.4,0,0,1,6.31-4.67,4.66,4.66,0,0,0,1.43,1.79,2.75,2.75,0,0,0,2.85.07,1.52,1.52,0,0,0,.58-1.19c.06-.46.1-.93.12-1.4a18.25,18.25,0,0,0-.09-2.66c.63-.44,1.27-.88,1.88-1.34.45-.34-.57-.55-.94-.28s-.7.49-1.05.74c-.07-.47-.15-.94-.25-1.41a2.5,2.5,0,0,0,1.67.31c1.63-.26,1.43-1.64,1.43-2.38a14,14,0,0,0-.27-2.4,35.68,35.68,0,0,0,2.86,2.33c.22.16.89.13,1-.1a4.3,4.3,0,0,0,.24-2.34,14.52,14.52,0,0,0,2.15,1.19c.26.12.95,0,.9-.21l-.48-2.31,1.7,1c.23.14.94.14,1-.1s.14-.56.2-.85a7,7,0,0,0,3.87.25,51.18,51.18,0,0,0,2.56,4.6,58.58,58.58,0,0,0,3.69,5.18c.31.39,1.6.09,1.29-.3a53.16,53.16,0,0,1-6.3-9.86,3.94,3.94,0,0,0,2.49-3.48A12.13,12.13,0,0,0,380,324.8C379.19,323.84,377.5,322,375.17,322.83Zm-22.9,41.45a13.23,13.23,0,0,1-2.38,5.14c-.11.14-.24.47-.44.56s-.17.09-.45,0a1.16,1.16,0,0,1-.33-.2,5.69,5.69,0,0,1-1.1-1.09,7.88,7.88,0,0,1-1.36-2.34c-1.22-3.3.15-6.8,2.66-9.79a22.31,22.31,0,0,1,2.2-2.27A16.81,16.81,0,0,1,352.27,364.28Zm5.25-22.2a8.71,8.71,0,0,1-.15,1.69c-.14-.47-.26-.95-.36-1.43a17.48,17.48,0,0,1-.33-4A9.42,9.42,0,0,1,357.52,342.08ZM342.34,338c-2.07-3.29-3.9-7.36.38-10.36a10.49,10.49,0,0,1,7.76-1.54,7,7,0,0,1,5.18,4.71,8.67,8.67,0,0,1,.17,5.51c-.07,0-.12.08-.13.14s0,.25,0,.37a16.36,16.36,0,0,1-2.35,4.51,25.18,25.18,0,0,1-5.2,5.22C346.22,343.64,344.15,340.81,342.34,338Zm6.22,9.25a24.87,24.87,0,0,0,7-7.27,18.21,18.21,0,0,0,1.29,5.74,2.56,2.56,0,0,1-2.11,1.91c-.61.11,0,.45.47.38a3.09,3.09,0,0,0,2.09-1.21c.2.43.42.87.65,1.29-2.19,1.5-4.36,3-6.3,4.6A47.27,47.27,0,0,0,348.56,347.2Zm13.58,1.72c0,.36.07,1-.34,1.34-.7.51-1.31-.14-1.59-.51a12.16,12.16,0,0,1-1-1.57c.85-.58,1.7-1.15,2.53-1.73l.44-.31A19.82,19.82,0,0,1,362.14,348.92ZM378,324.46a12.36,12.36,0,0,1,1.5,1.88,11.8,11.8,0,0,1,1.71,4.28,7.92,7.92,0,0,1-.09,4.37A3,3,0,0,1,380,336.4a43.58,43.58,0,0,1-2.82-7.89,37.49,37.49,0,0,1-.9-5.22C377,323.34,377.83,324.23,378,324.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,334.42c-.85,1-1.12,2.21-2.9,2.84a4.66,4.66,0,0,1-2.21.24h0a3.05,3.05,0,0,0-1.18-2.23,1.82,1.82,0,0,0-2.06,0c-.55.48.08,1.2.5,1.64a3.68,3.68,0,0,0,1.64.93,2.43,2.43,0,0,1-.25,1.2c-.05.12-.73,1.25-1,1.15s-.79.08-.42.24c1.59.69,2.57-1.47,2.72-2a2.32,2.32,0,0,0,.07-.38,7.21,7.21,0,0,0,2.34-.18c2.16-.55,3.59-2.08,3.79-3.39C396.57,334.22,395.73,334.23,395.56,334.42Zm-7.1,1.82c0-.08-.4-.75-.22-.73,0,0,.24.31.26.34l.28.33a2.85,2.85,0,0,1,.4.8A2.94,2.94,0,0,1,388.46,336.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.78,330.67c-.31.18.35.4.61.25S392,330.52,391.78,330.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,352.81l-4.28,2.05c10,6.85,28.37,7.53,41,1.51l-3.38-2.32C376.83,358.94,361.88,358.39,353.77,352.81ZM359.33,335c-9.09,4.34-10.64,11.89-3.45,16.83s20.44,5.43,29.54,1.09,10.64-11.89,3.45-16.83S368.42,330.64,359.33,335Zm24.4,16.76c-7.92,3.77-19.45,3.35-25.71-.95a11.75,11.75,0,0,1-1.19-.94l28.45,1C384.79,351.19,384.28,351.47,383.73,351.74Zm3.66-2.32-32-1.18c-2.26-3.18-1.47-6.91,2.09-9.86l31.88,1.18C391.64,342.73,390.9,346.46,387.39,349.42ZM359.57,336.9c.46-.26.94-.52,1.45-.76,7.92-3.78,19.45-3.35,25.71.95a12.51,12.51,0,0,1,1.11.86Zm-14.33,20c11.84,8.13,33.63,8.94,48.59,1.8s17.51-19.56,5.68-27.69-33.63-8.93-48.59-1.79S333.41,348.76,345.24,356.88ZM397.37,332c10.9,7.49,8.55,18.93-5.23,25.51s-33.86,5.83-44.76-1.66-8.55-18.93,5.23-25.5S386.47,324.52,397.37,332Zm-39.71,1.82c10.26-4.9,25.2-4.34,33.32,1.23l4.28-2c-10-6.86-28.37-7.54-41-1.52Z",
    style: {
      fill: "#9D7600",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75, -0.43, 0.87, 0.5, 134.59, 285.25)",
    style: {
      fontSize: "35.69664001464844px",
      fill: "#9D7600",
      fontFamily: "Rubik-Bold, Rubik",
      fontWeight: 700
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-0.049002876349859684em"
    }
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.74,
    y: 0,
    style: {
      letterSpacing: "-0.06998605805196723em"
    }
  }, "A"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 45.87,
    y: 0
  }, "TEN")), /*#__PURE__*/React.createElement("tspan", {
    x: 117.26,
    y: 0,
    style: {
      letterSpacing: "-0.023984163654234305em"
    }
  }, "T")))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 169.18,
    cy: 339.96,
    rx: 55.38,
    ry: 31.97,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M332.53,395.19a25.21,25.21,0,0,0-9.55-8.85,44.15,44.15,0,0,0-11.45-4.62l-1.09-.31a31.12,31.12,0,0,1-7.19-2.93c-4.62-2.67-5.76-5.33-5.76-5.33l-.58-1.68-16.34-2.79-1.1,1.12a20,20,0,0,1-8.41,4.73l-8.45-4.87c-7-4-18-4-25,0-3.86,2.23-6,5.36-6,8.82s2.13,6.59,6,8.82l6,3.47c-.51.2-1,.39-1.6.57l-3.34,1.09,5.46,10.66.74,1.43,1.59.18a32.35,32.35,0,0,1,10.87,3.72,17.44,17.44,0,0,1,4.8,3.89l.51.61a26.9,26.9,0,0,0,8.31,6.89,45,45,0,0,0,14.38,5.23,68.23,68.23,0,0,0,13,1.13A150.58,150.58,0,0,0,326.87,423l1.31-.26.69-1.15C335.23,410.8,336.46,401.93,332.53,395.19Zm-74.3-18.9c-.83,0-1.65,0-2.46-.05l-3.58-.16.48,3.55c.4,3-.85,5.78-3.52,8-2.65-1.53-5.91-3.4-8.8-5.08-2.07-1.19-3.25-2.67-3.25-4.06s1.18-2.87,3.25-4.06c5.3-3.07,14.24-3.08,19.51,0l2.91,1.67C261.31,376.22,259.79,376.29,258.23,376.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M334.4,455.29c1.52,4.12,5.91,6.68,13.23,7.64L452,401.81l13.58-13.75a1.06,1.06,0,0,0-1.09-1.74l-25,8.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M184.87,464.38a11.38,11.38,0,0,0,5.62-1.38l4.23-2.44a4.75,4.75,0,0,0,0-8.81L139,419.47c5-5.51,7.18-11.72,6.4-18.08-1-8.1-6.92-15.67-16.69-21.31-10.59-6.11-24.63-9.48-39.53-9.48S60.21,374,49.62,380.08c-10.86,6.27-16.84,14.71-16.84,23.75s6,17.49,16.84,23.76c10.59,6.11,24.62,9.47,39.52,9.47h0c14.36,0,27.93-3.13,38.37-8.82l51.06,34.41A11.58,11.58,0,0,0,184.87,464.38Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.22,389.51v13.3c0,7.22,4.77,14.44,14.31,19.95,19.08,11,50,11,69.1,0C134.18,417.25,139,410,139,402.81v-13.3h0c0-7.22-4.77-14.44-14.31-19.94-19.09-11-50-11-69.11,0-9.54,5.5-14.31,12.72-14.31,19.94Zm93,0c0,5.77-4.24,11.4-12,15.85-8.52,4.92-20,7.63-32.19,7.63s-23.67-2.71-32.19-7.63c-7.7-4.45-12-10.08-12-15.85s4.25-11.41,12-15.86c8.52-4.92,20-7.63,32.19-7.63s23.67,2.71,32.19,7.63C130,378.11,134.22,383.74,134.22,389.52Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,369.57c-19.08-11-50-11-69.11,0s-19.08,28.88,0,39.89,50,11,69.11,0S143.72,380.58,124.64,369.57Zm-2.36,35.8c-8.53,4.92-20,7.63-32.2,7.63s-23.66-2.71-32.19-7.63C50.19,400.92,46,395.29,46,389.52s4.24-11.41,11.94-15.86c8.53-4.92,20-7.63,32.19-7.63s23.67,2.71,32.2,7.63c7.7,4.45,11.94,10.08,11.94,15.86S130,400.92,122.28,405.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,389.51a13.11,13.11,0,0,1-1.91,6.66c-1.94-3.36-5.35-6.51-10-9.21-8.51-4.92-20-7.64-32.19-7.64S66.41,382,57.9,387c-4.7,2.7-8.11,5.85-10.06,9.21a13.2,13.2,0,0,1-1.9-6.66c0-5.77,4.25-11.4,12-15.86,8.51-4.91,19.95-7.62,32.18-7.62s23.68,2.71,32.19,7.62C130,378.11,134.23,383.74,134.23,389.51Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,389.51a13.11,13.11,0,0,1-1.91,6.66c-1.94-3.36-5.35-6.51-10-9.21-8.51-4.92-20-7.64-32.19-7.64S66.41,382,57.9,387c-4.7,2.7-8.11,5.85-10.06,9.21a13.2,13.2,0,0,1-1.9-6.66c0-5.77,4.25-11.4,12-15.86,8.51-4.91,19.95-7.62,32.18-7.62s23.68,2.71,32.19,7.62C130,378.11,134.23,383.74,134.23,389.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,379.68c-8.53-4.92-20-7.63-32.2-7.63s-23.66,2.71-32.19,7.63c-6.35,3.67-10.35,8.15-11.55,12.85,1.2,4.69,5.2,9.17,11.55,12.84,8.53,4.92,20,7.63,32.19,7.63s23.67-2.71,32.2-7.63c6.35-3.67,10.35-8.15,11.55-12.84C132.63,387.83,128.63,383.35,122.28,379.68Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,416.94v13.29a63.92,63.92,0,0,0,23-7.47C134.18,417.25,139,410,139,402.81v-13.3a16.64,16.64,0,0,0-.59-4.35h0c2.31,8.59-2.26,17.68-13.73,24.31A64.31,64.31,0,0,1,101.6,416.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.18,417.93a7.58,7.58,0,0,1,3.4-5.94,2.41,2.41,0,0,1,2.41-.26h0l16.45,9.38h0a2.42,2.42,0,0,1,1,2.21,7.55,7.55,0,0,1-3.4,5.94,2.39,2.39,0,0,1-2.42.25h0l-16.45-9.38h0A2.43,2.43,0,0,1,123.18,417.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,420.15a2.43,2.43,0,0,1-1-2.22,6.54,6.54,0,0,1,.58-2.56L145,427.5a6.54,6.54,0,0,1-1.91,1.78,2.39,2.39,0,0,1-2.42.25l-16.45-9.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,429.24a9.84,9.84,0,0,1,4.43-7.74,3.14,3.14,0,0,1,3.1-.34h0l.05,0h0l42.74,22.39L182.47,458l-40.85-25.84A3.14,3.14,0,0,1,140.29,429.24Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,458l-40.85-25.84a3.14,3.14,0,0,1-1.33-2.88,9.39,9.39,0,0,1,1.48-4.7l44.89,26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,457.53a12.91,12.91,0,0,0,5.8-10.15c0-3.73-2.63-5.23-5.85-3.35a12.93,12.93,0,0,0-5.81,10.14C180.74,457.9,183.36,459.4,186.58,457.53Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.58,457.53a12.91,12.91,0,0,0,5.8-10.15c0-3.73-2.63-5.23-5.85-3.35a12.93,12.93,0,0,0-5.81,10.14C180.74,457.9,183.36,459.4,186.58,457.53Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.48,385.3l22.24-4.36a.69.69,0,0,1,.65,1.14l-15.09,17.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.37,382.08a.69.69,0,0,0-.65-1.14l-4.34.85h0a3.83,3.83,0,0,1,1.79,3.55l0,.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,446.72l1.82-1.05,2.2-1.25,78.9-45.26a10.14,10.14,0,0,0-.62-7.37c-1.57-3.53-4.64-6.32-7.17-6.48l-78.86,45.23-4.2,2.41C360.24,431.54,368.15,445.27,365.36,446.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.3,442.77l4.06-2.34c1.19-.64.51-3.58-.9-6.63-1.85-4.05-5.5-8-7.09-7.13l-3,1.72-1.06.64c1.6-.85,5.25,3.07,7.1,7.12,1.34,2.92,2,5.76,1,6.53h0A.27.27,0,0,1,372.3,442.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,442.17c2.79-1.47-5.19-15.22-8-13.74l-4.07,2.33c2.79-1.48,10.77,12.26,8,13.74Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,446.72l4-2.3c2.74-1.43-4.85-14.76-7.75-13.88l-.17.06-4,2.35C360.24,431.54,368.15,445.27,365.36,446.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.47,381.33l-.75-.39-16.14,8.83-83.43,47.88c-.16-.25-.29-.27-.39-.1,2.37,3.7,4.16,8.35,2.6,9.17l1.82-1.05,2.2-1.25,78.9-45.26h0l15.09-17.08A.68.68,0,0,0,463.47,381.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.31,456.47l17.05-9.75c1.19-.62.53-3.54-.85-6.57-1.84-4.06-5.47-8-7.08-7.2h0l-17.1,9.8c-3.39,2-.27,9.33,3.52,12.63C345.24,456.62,346.81,457.17,348.31,456.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.33,451.18c-1-3.84-4.09-7.61-7-8.41a2.77,2.77,0,0,0-2.55.34c-2.56,2.38.42,9.15,4,12.27,1.38,1.22,2.92,1.76,4.39,1.12C349.5,455.75,350,453.79,349.33,451.18Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lock--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.61,387.64l-14-8.08c-3.86-2.23-6-5.36-6-8.82s2.13-6.59,6-8.82c7-4.06,18-4.07,25,0l13.95,8-2.75,4.76-13.95-8c-5.27-3-14.21-3-19.51,0-2.07,1.19-3.25,2.67-3.25,4.06s1.18,2.87,3.25,4.06l14,8.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,387.64a22,22,0,0,0-8.46-7.76,44.16,44.16,0,0,0-11.87-4.64,34.49,34.49,0,0,1-7.86-3.22c-5.87-3.4-7.1-6.95-7.1-6.95l-13-2.23c-5.81,5.94-16.56,7.75-26,7.33.73,5.44-2.42,11.64-12.7,15v9l3.86,7.53a35,35,0,0,1,12,4.1,20.32,20.32,0,0,1,5.58,4.54,24.68,24.68,0,0,0,8,6.85,41.5,41.5,0,0,0,13.45,4.88c9.41,1.83,22.48,1.43,40.39-2.1,3.8-6.43,5.51-11.78,5.49-16.21,0-1.5,0-7.41,0-8.87A14,14,0,0,0,329.94,387.64Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.94,387.64a22,22,0,0,0-8.46-7.76,44.16,44.16,0,0,0-11.87-4.64,34.49,34.49,0,0,1-7.86-3.22c-5.87-3.4-7.1-6.95-7.1-6.95l-13-2.23c-5.81,5.94-16.56,7.75-26,7.33.73,5.44-2.42,11.64-12.7,15v9l3.86,7.53a35,35,0,0,1,12,4.1,20.32,20.32,0,0,1,5.58,4.54,24.68,24.68,0,0,0,8,6.85,41.5,41.5,0,0,0,13.45,4.88c9.41,1.83,22.48,1.43,40.39-2.1,3.8-6.43,5.51-11.78,5.49-16.21,0-1.5,0-7.41,0-8.87A14,14,0,0,0,329.94,387.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.29,411c-17.91,3.54-31,3.94-40.39,2.11a41.9,41.9,0,0,1-13.46-4.88,24.84,24.84,0,0,1-8-6.86,20.49,20.49,0,0,0-5.58-4.53,34.79,34.79,0,0,0-12-4.1l-3.86-7.53c10.28-3.36,13.43-9.56,12.7-15,9.41.42,20.16-1.39,26-7.33l13,2.23s1.23,3.55,7.1,6.95a34.49,34.49,0,0,0,7.86,3.22,44.16,44.16,0,0,1,11.87,4.64,22,22,0,0,1,8.46,7.76C333.11,393.08,332.41,400.62,326.29,411Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,411c-17.91,3.54-31,3.94-40.39,2.11a41.9,41.9,0,0,1-13.46-4.88,24.84,24.84,0,0,1-8-6.86,20.49,20.49,0,0,0-5.58-4.53,34.79,34.79,0,0,0-12-4.1l-3.86-7.53c10.28-3.36,13.43-9.56,12.7-15,9.41.42,20.16-1.39,26-7.33l13,2.23s1.23,3.55,7.1,6.95a34.49,34.49,0,0,0,7.86,3.22,44.16,44.16,0,0,1,11.87,4.64,22,22,0,0,1,8.46,7.76C333.11,393.08,332.41,400.62,326.29,411Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,409.71a61,61,0,0,1-11.56-1,37.18,37.18,0,0,1-12.08-4.37,19.65,19.65,0,0,1-6.32-5.21l-.57-.68A24.61,24.61,0,0,0,261,393a39.42,39.42,0,0,0-11.3-4.25l-.66-1.28c7.44-3.7,10-8.84,10.77-12.81,6.38-.17,16.25-1.44,23.14-7.06l8.84,1.51a23.19,23.19,0,0,0,7.71,6.77,38,38,0,0,0,8.86,3.64l1.13.32a37.07,37.07,0,0,1,9.74,3.9c3.39,2,5.5,3.86,6.84,6.16,2.31,3.95,1.41,9.71-2.66,17.13A139.2,139.2,0,0,1,298.3,409.71Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,409.71a61,61,0,0,1-11.56-1,37.18,37.18,0,0,1-12.08-4.37,19.65,19.65,0,0,1-6.32-5.21l-.57-.68A24.61,24.61,0,0,0,261,393a39.42,39.42,0,0,0-11.3-4.25l-.66-1.28c7.44-3.7,10-8.84,10.77-12.81,6.38-.17,16.25-1.44,23.14-7.06l8.84,1.51a23.19,23.19,0,0,0,7.71,6.77,38,38,0,0,0,8.86,3.64l1.13.32a37.07,37.07,0,0,1,9.74,3.9c3.39,2,5.5,3.86,6.84,6.16,2.31,3.95,1.41,9.71-2.66,17.13A139.2,139.2,0,0,1,298.3,409.71Z",
    style: {
      fill: "#9D7600",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,409.71a61,61,0,0,1-11.56-1,37.18,37.18,0,0,1-12.08-4.37,19.65,19.65,0,0,1-6.32-5.21l-.57-.68A24.61,24.61,0,0,0,261,393a39.42,39.42,0,0,0-11.3-4.25l-.66-1.28c7.44-3.7,10-8.84,10.77-12.81,6.38-.17,16.25-1.44,23.14-7.06l8.84,1.51a23.19,23.19,0,0,0,7.71,6.77,38,38,0,0,0,8.86,3.64l1.13.32a37.07,37.07,0,0,1,9.74,3.9c3.39,2,5.5,3.86,6.84,6.16,2.31,3.95,1.41,9.71-2.66,17.13A139.2,139.2,0,0,1,298.3,409.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,398.46l.57.68a19.65,19.65,0,0,0,6.32,5.21,37.18,37.18,0,0,0,12.08,4.37,61,61,0,0,0,11.56,1A139.2,139.2,0,0,0,323.45,407a30.56,30.56,0,0,0,3.75-10.09,9.12,9.12,0,0,0-1.09-3.08c-1.34-2.3-3.45-4.21-6.84-6.16a37.42,37.42,0,0,0-9.74-3.9l-1.13-.32a38,38,0,0,1-8.86-3.64,23.19,23.19,0,0,1-7.71-6.77L283,371.53c-6.89,5.62-16.76,6.89-23.14,7.07a17,17,0,0,1-7.39,10.8A37.64,37.64,0,0,1,261,393,24.61,24.61,0,0,1,267.77,398.46Z",
    style: {
      fill: "#9D7600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,396.32,300,402.83l-15-10.7a15.4,15.4,0,0,1-7.63-1.86c-3.88-2.24-4.31-5.64-.94-7.58s9.25-1.7,13.14.54c2.18,1.26,3.27,2.88,3.22,4.41Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,396.32,300,402.83l-15-10.7a15.4,15.4,0,0,1-7.63-1.86c-3.88-2.24-4.31-5.64-.94-7.58s9.25-1.7,13.14.54c2.18,1.26,3.27,2.88,3.22,4.41Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.99 367.57 282.99 371.53 291.83 373.04 291.83 369.08 282.99 367.57",
    style: {
      fill: "#9D7600",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,374.63v4a17.07,17.07,0,0,1-7.39,10.8c-1-.29-2-.51-2.72-.68l-.65-1.28C256.52,383.74,259.08,378.6,259.85,374.63Z",
    style: {
      fill: "#9D7600",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.02 402.83 311.29 396.32 292.75 387.64 292.75 397.66 300.02 402.83",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.8 392.7 246.8 401.7 242.94 394.17 242.94 385.17 246.8 392.7",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.8 392.7 246.8 401.7 242.94 394.17 242.94 385.17 246.8 392.7",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78,403.76c0,4.43-1.68,9.78-5.5,16.2v-9c3.67-6.2,5.4-11.4,5.5-15.74C331.77,397.09,331.78,402.35,331.78,403.76Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78,403.76c0,4.43-1.68,9.78-5.5,16.2v-9c3.67-6.2,5.4-11.4,5.5-15.74C331.77,397.09,331.78,402.35,331.78,403.76Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.15,332.55a5.86,5.86,0,0,0,.33-3.72,22.35,22.35,0,0,0-2.09-5.1,32.76,32.76,0,0,1-2.21-21.38c.75-3.16,3.23-5.58,5.36-7.93,4.63-5.08,9.68-9.79,14.75-14.42l-17-17.5c-3.57,5.71-13.67,24.89-13.67,24.89l-1.11,2.05c-.36.44-.56,1-.88,1.42A13.62,13.62,0,0,1,136,292.4l-3.14,3.06a8.09,8.09,0,0,0-2.28,3.06c-.75,2.27.62,4.63,1.37,6.9,1.22,3.7.83,7.71,1,11.6a11.62,11.62,0,0,0,3.25,8.24,30.64,30.64,0,0,0,10.55,8.17,7.93,7.93,0,0,0,4.33.63C152.09,333.94,153.58,333.51,154.15,332.55Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86,297.77a8.74,8.74,0,0,0-1.24,3.22c-.26,1.18,2.43,5.8,2.66,8.14s0,3.08,0,6.12c0,3.36-1,6.84,4.32,13.43s10.42,8.7,14.29,9.3a9,9,0,0,0,4.16-.57s3.51-3.19,1.92-5.38S128.86,297.77,128.86,297.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.89,300.38c.19.82-.38,1.78-.83,3.53a20.06,20.06,0,0,0-.26,7.51c2.25,12.85,6.67,17.81,3.49,23.42-1.16,2.05-5.36,3.09-14.16-2.1-4.49-2.65-9.29-9.84-9.53-13.87s.44-7,.11-10-3.44-8.15-2.85-11.1c.48-2,2.66-4.1,3.51-4.79a35.94,35.94,0,0,0,4.49-4.15c1-1.21,1.66-2,2.73-1.44l-1.1,2.05c-1,3.71-.83,4.47-.66,6.12.22,2.18,1,3.1,1.31,4.81.75-2.46.72-4.44,2.43-4.89.93-.24,1.91-.3,5.09,1S152.72,299.65,152.89,300.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,332.77c-4.49-2.65-9.3-9.84-9.53-13.87a33,33,0,0,1,0-4c0,.26.07.54.11.76.11.48.24,1,.37,1.45a11.5,11.5,0,0,0,2.72,5.16c1.26,1.22,4.27,4.32,6.3,3.62,1.15-.4,1.67-1.89,1.61-3.32,0-.61-.29-2.17-.29-2.17a18.85,18.85,0,0,1,6,.07c3.66.78,3.72,1.25,3.72,1.25a8.5,8.5,0,0,0,.91,2.58,6.36,6.36,0,0,0,1.76,2,4.21,4.21,0,0,0,.88.38c1,2.79,1.5,5.27-.44,8.19C154,336.77,150,338,141.2,332.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,307.2s0,0,0,0a4.5,4.5,0,0,0-.27,1.83,48,48,0,0,0,.8,8.44,6.52,6.52,0,0,1-.18,3.2,7.09,7.09,0,0,0-.55,1.19.75.75,0,0,0,.31.88,1.37,1.37,0,0,0,1.52.21,2,2,0,0,0,.69-.94c.11-.23.22-.47.31-.71a83.19,83.19,0,0,1-2.42-9.9A18.75,18.75,0,0,1,151.6,307.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,294.64a19.1,19.1,0,0,1,.4-5.12c.23-.25.45-.49.62-.69,1-1.21,1.66-2,2.73-1.44l-1.1,2.05a15.31,15.31,0,0,0-.24,5.41c.38,2.47.56,3.81.89,5.52.82,5.63.4,7.79,1.75,12.89s3.61,8,3,8.54-2.19.54-4-3.27-2.65-11-2.66-14.64S136.14,298.25,135.84,294.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.28,320.34a.48.48,0,0,0,.29.06,12.59,12.59,0,0,1,9.4,2.45.53.53,0,0,0,.72-.14.52.52,0,0,0-.14-.72,13.51,13.51,0,0,0-10.05-2.63.53.53,0,0,0-.22,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,316.35a.49.49,0,0,0,.29.06,14,14,0,0,1,10,2.34.52.52,0,0,0,.74-.18.55.55,0,0,0-.18-.74,15.09,15.09,0,0,0-10.7-2.49.54.54,0,0,0-.2,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,312.05a.61.61,0,0,0,.33.06,16,16,0,0,1,11.28,2.48.59.59,0,0,0,.81-.21.6.6,0,0,0-.21-.81,17.17,17.17,0,0,0-12-2.64.59.59,0,0,0-.52.65A.6.6,0,0,0,140.17,312.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,307.58a.5.5,0,0,0,.32.06,15.54,15.54,0,0,1,11,2.52.59.59,0,0,0,.79-.2.58.58,0,0,0-.2-.8,16.64,16.64,0,0,0-11.71-2.67.57.57,0,0,0-.52.63A.56.56,0,0,0,139.7,307.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.32,303a.58.58,0,0,0,.32.07c4.21-.29,7.28.68,11.36,3.27a.58.58,0,0,0,.8-.17.56.56,0,0,0-.18-.8c-4.29-2.73-7.6-3.77-12.06-3.46a.59.59,0,0,0-.54.62A.56.56,0,0,0,139.32,303Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,141.43c1.41,9.73,6,21.95,8.55,45,2.39,21.63,3.45,32.9,1.94,43.66-.54,3.83-2.47,8.32-6.15,14-11.54,17.76-34.24,45.71-34.24,45.71s-5.15-.08-11.38-5.16a17.89,17.89,0,0,1-6.29-12.18s.6-4.05,10.12-20.42S174.32,218,174.32,218l-6.21-69.44C182.89,149.86,194.14,147.09,201,141.43Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75,284.63a17.89,17.89,0,0,1-6.29-12.18s.6-4.05,10.12-20.42S174.32,218,174.32,218l-4.75-53.16c11.56-1.82,27.7-1.67,27.7-1.67.3,7.6-1.35,17-12.06,22.69,0,0,2,37.39,2.23,48.33.19,8.35-2.19,29.6-3.33,39.21-7.2,9.33-13,16.44-13,16.44S166,289.71,159.75,284.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,340.83s-7.59-9.47-7.59-21S181,288.81,181,288.81l-23.49,6,5.16,30.72.27,2.42s-1.34,13.42,9.15,13.81A135.84,135.84,0,0,0,187.36,340.83Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,340.83a9.19,9.19,0,0,0,.85,3.51c.48,1.17,5.55,3.55,7.13,5.42s1.82,2.67,3.66,5.26c2,2.87,3.23,6.46,11.7,9s14.15,1.28,17.83-.51a9.27,9.27,0,0,0,3.24-3s1.12-4.83-1.55-5.76S159.64,340.83,159.64,340.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,328.78c.65.59.74,1.75,1.4,3.53a20.61,20.61,0,0,0,4.25,6.61c9.57,9.71,16.33,11.36,16.94,18.08.22,2.45-2.78,5.85-13.43,6.62-5.44.39-13.86-2.94-16.46-6.26s-3.77-6.26-5.86-8.68-7.81-5-9.06-7.85c-.77-2-.15-5.1.17-6.21a37.4,37.4,0,0,0,1.39-6.23c.12-1.62.24-2.7,1.49-2.87l.27,2.42c1.4,3.76,2,4.34,3.08,5.66,1.48,1.74,2.69,2.08,4,3.35-.81-2.56-2-4.24-.82-5.64.66-.77,1.47-1.4,4.95-2.21S181.28,328.25,181.86,328.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.09,363.6c-5.44.4-13.86-2.94-16.46-6.25a36.12,36.12,0,0,1-2.36-3.44c.19.19.38.41.55.57.38.36.78.71,1.18,1a12,12,0,0,0,5.41,2.82c1.81.3,6.25,1.18,7.58-.64.75-1,.31-2.62-.6-3.82-.38-.5-1.54-1.69-1.54-1.69a19.57,19.57,0,0,1,5.24-3.52c3.6-1.51,3.93-1.15,3.93-1.15a8.87,8.87,0,0,0,2.32,1.68,6.79,6.79,0,0,0,2.7.67,4,4,0,0,0,1-.2c2.48,1.83,4.42,3.64,4.49,7.31C204.45,359.45,201.74,362.84,191.09,363.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.82,335.41v0a4.87,4.87,0,0,0,.87,1.73,50.46,50.46,0,0,0,5.71,6.79,6.81,6.81,0,0,1,1.75,2.86,6.6,6.6,0,0,0,.24,1.34c.2.43.32.53.78.58a1.46,1.46,0,0,0,1.44-.72,2.11,2.11,0,0,0,0-1.22c0-.27-.09-.54-.15-.8a85.27,85.27,0,0,1-8-7.08A19.6,19.6,0,0,1,184.82,335.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78,334a19.75,19.75,0,0,1-2.7-4.64c0-.35.1-.68.12-.95.12-1.62.24-2.7,1.49-2.87l.27,2.42a16.67,16.67,0,0,0,3,4.8c1.8,1.89,2.75,2.94,4.05,4.21,4.07,4.36,5,6.47,9.18,10.06s7.86,4.72,7.69,5.53-1.56,1.77-5.37-.44-8.85-7.92-11-11S166.19,336.92,163.78,334Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,352.26a.56.56,0,0,0,.29-.12,13.12,13.12,0,0,1,9.54-3.48.55.55,0,1,0,0-1.09,14.12,14.12,0,0,0-10.2,3.72.54.54,0,0,0-.09.77A.53.53,0,0,0,184.62,352.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,349.31a.56.56,0,0,0,.29-.12,14.61,14.61,0,0,1,10-4,.55.55,0,0,0,.53-.6.56.56,0,0,0-.59-.52,15.73,15.73,0,0,0-10.69,4.22.56.56,0,0,0,.43,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,346.39a.62.62,0,0,0,.32-.14c3.42-2.94,6-4.2,11.18-4.58a.62.62,0,0,0-.09-1.24c-5.41.41-8.27,1.77-11.9,4.88a.61.61,0,0,0-.06.87A.59.59,0,0,0,177.87,346.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81,342.83a.62.62,0,0,0,.31-.14,16.21,16.21,0,0,1,11-4.39.62.62,0,0,0,.57-.65.61.61,0,0,0-.65-.56,17.36,17.36,0,0,0-11.66,4.67.62.62,0,0,0-.08.86A.64.64,0,0,0,174.81,342.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,339.11a.61.61,0,0,0,.31-.13c3.45-2.76,6.66-3.75,11.73-4a.61.61,0,0,0-.05-1.21c-5.32.21-8.78,1.29-12.44,4.21a.61.61,0,0,0-.09.86A.62.62,0,0,0,171.76,339.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,141.43s1.88,12.57-2.13,24c-3.48,9.95-10.16,15.56-17.19,17.9,0,0,2.33,44.73,3,50.95s-.84,28.78-2.16,43.63-1.72,19.93-1.72,19.93-3.1,3.35-11.78,3.52-11.44-3.5-11.44-3.5-5.48-17.16-5.72-30.63c-.13-7.72,1.53-11.55.09-19.2s-12-41.73-13.84-57.88.9-30.34,12.14-46.88C162.32,151.38,190,149.35,201,141.43Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.19,145.81c-6.09,8.59-14.86,26.31-8.64,51.69,1.77,7.22,3.54,14.18,5.25,20.92,4,15.77,7.16,28.23,7.58,33a38.65,38.65,0,0,1-.38,8,68.66,68.66,0,0,0,0,18.87c1.09,8.12,2.67,16.66,3.81,22.44-.36-.1-.71-.2-1-.31-1.14-5.78-2.67-14.09-3.73-22a69.09,69.09,0,0,1,0-19.1,38.49,38.49,0,0,0,.38-7.84c-.42-4.68-3.57-17.1-7.56-32.84q-2.56-10.11-5.24-20.92c-6.27-25.57,2.47-43.49,8.65-52.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.65,100c3.82-1.85,5.11-4.42,7.18-6.48,2.62-2.62,5.66-4.09,10.2-7,.78-.51,1.56-1,2.34-1.49a9.93,9.93,0,0,0,1.12-.75c.33-.27.61-.49,1.07-.19a1.57,1.57,0,0,1,.59,1,4.44,4.44,0,0,1-.83,3.56,21.37,21.37,0,0,1-2.56,2.74c-.67.69.43.85,1,.85,2.6,0,7.69-5,9.85-6.25,1-.6,1.68-1.75,3-1.19a6.9,6.9,0,0,0,1.28.56,5.49,5.49,0,0,0,1.46,0,3.23,3.23,0,0,1,2.07.55,1.89,1.89,0,0,1,.75,1.91c-.16.55-.63,1-.69,1.54a5.29,5.29,0,0,0,.05.8c.05,1.19-.93,2.12-1.59,3.1s-.79,1.84-1.32,2.71a18.6,18.6,0,0,1-1.78,2.65,37.92,37.92,0,0,1-5.48,5.12,25.94,25.94,0,0,1-9.3,3.87,16.64,16.64,0,0,0-7.72,3.18c-4,2.73-19,13-25.61,16.45-8,4.19-10.34,5.55-19,.3-5.71-3.49-25.44-19.95-25.44-19.95l-4.62-24.93s9.56-1.76,21.22,9.39c8.34,8,18.18,17.36,18.18,17.36S238.42,101.6,241.65,100Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,94.11c.32,4.08-3.57,7.84-5.82,9,0,0,3.84-1,5.3-3.36C260.82,97.16,260.49,95.63,259.74,94.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,25.17a5.6,5.6,0,0,0-3.69,3.23c-.74,2-.19,4.53-1.73,6a2.87,2.87,0,0,1-4.17-.51,2.35,2.35,0,0,0-.29,2.55,2.33,2.33,0,0,0,2.27,1.21,6.4,6.4,0,0,0-3,10.47,4.48,4.48,0,0,1,.82,1c.45.93,0,2-.41,3a8.84,8.84,0,0,0-.71,5.15,5.62,5.62,0,0,0,3.1,3.94,4.77,4.77,0,0,1,.35-4A6.08,6.08,0,0,0,134,63.42a12,12,0,0,0,6.55-.08,31.26,31.26,0,0,1,5.79-1.58c1.11-.11,2.22,0,3.32-.19a8,8,0,0,0,5.42-3.42,7.92,7.92,0,0,0,1.25-5.5c-.33-2.08,1-3.67,2.16-5.37,1.36-2,2.64-4.53,1.82-6.83-.72-2-2.92-3.39-3.21-5.52-.18-1.27.4-2.43.25-3.7A7.16,7.16,0,0,0,156.05,28a7.77,7.77,0,0,0-5.29-3.35c-2.48-.32-4.89.58-7.36.51C141.38,25.1,139.35,24.56,137.35,25.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.71,121.85s4.63-2.29,5.89-12.59c.57-4.67-1-10.77-2.95-17.81L154.8,85.6s4.34-1.23,13.94-3l8.9,0s16,6.92,22.54,15.66c3.56,4.78,7.24,14.94,1,22.68.48,6.92.57,21,.57,21s-3.68,6.82-21.35,8.88c-25.36,3-32.42-6.49-32.42-6.49C147.47,136.94,141.38,129,138.71,121.85Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,121.85s4.63-2.29,5.89-12.59c.57-4.67-1-10.77-2.95-17.81L154.8,85.6s4.34-1.23,13.94-3l8.9,0s16,6.92,22.54,15.66c3.56,4.78,7.24,14.94,1,22.68.48,6.92.57,21,.57,21s-3.68,6.82-21.35,8.88c-25.36,3-32.42-6.49-32.42-6.49C147.47,136.94,141.38,129,138.71,121.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,123.35s-3.66,6.34-13.47,6.1-12.73-7.36-12.73-7.36.75,9.61,12.48,9.85C180.16,132.17,182.34,123.35,182.34,123.35Z",
    style: {
      fill: "#9D7600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.49,33.89a10.34,10.34,0,0,1,5.45-3.5c2-.52,3.29-.49,5.24-1.3s3.44-2.1,5.28-2.89a11.83,11.83,0,0,1,9.14.15c2.88,1.19,4.67,3.85,7.72,4.58,1.59.38,3.25.46,4.83.89a10.43,10.43,0,0,1,6.46,4.88,8.47,8.47,0,0,1,.15,8,6.06,6.06,0,0,0-1,2.19c-.14,1.5,1.24,2.65,1.9,4,1.15,2.31,0,5.27-2,6.84a11.37,11.37,0,0,1-7.33,1.9,17.36,17.36,0,0,1-5.4,10,39.6,39.6,0,0,1-6.17,4.78,31.11,31.11,0,0,1-6.14,2.85c-2.19.86-6.13,2.47-8.28.72a9.2,9.2,0,0,1-2-2.72c-2-3.55-4.77-6.64-7.33-9.83s-5-6.58-6.29-10.47a15.34,15.34,0,0,1-.37-9,13,13,0,0,1,1.42-3.44,4.06,4.06,0,0,1,3.49-2A8.89,8.89,0,0,1,146.49,33.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54,57.19c2.48-1.06,4.64-.18,6.07,2.47,1.25,2.31,3.68,1.4,3-2.23,5.47-5.69-1.21-9,3.27-14.45,2.79-3.41,9-2.74,11.57-.75a6,6,0,0,1,6.92-3.12c2.64.85,4.35,2.39,5.72,6,1.43,3.8.1,4.57.83,7.27a20.37,20.37,0,0,1,1.51,5.77c.62,12.72-1.86,16-4.54,18.21-1.84,1.5-4.22,2.34-8.32,2.53l.38,5.54a28.82,28.82,0,0,1,6.2,14.84c-11.85-3.1-18-7.19-24.93-12.53L153,68.32h0c-.54,1.47-3.38,3.16-6.36.83C142.88,66.2,142.17,59.08,146.54,57.19Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,50.57l-4-1.52a2.06,2.06,0,0,1,2.7-1.35A2.33,2.33,0,0,1,181.06,50.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,49.89l-3.71,2.24a2.14,2.14,0,0,1,.68-3A2.23,2.23,0,0,1,165.62,49.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,65.05l6,1.91A3.14,3.14,0,0,1,170,69,3,3,0,0,1,168.17,65.05Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69,69.14a3.33,3.33,0,0,0-3.36-3c-.1,0-.2,0-.3,0A2.84,2.84,0,0,0,170,69,3.46,3.46,0,0,0,171.69,69.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.63 52.1 172.94 63.47 179.03 61.13 171.63 52.1",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46,55.7a1.8,1.8,0,1,1-3.6.24,1.84,1.84,0,0,1,1.68-2A1.81,1.81,0,0,1,167.46,55.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,54.47a1.8,1.8,0,1,1-1.92-1.72A1.84,1.84,0,0,1,181,54.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,78.93c-4-.11-10.79-.11-14.22-4.59,0,0,.52,2.72,4.65,4.71,2.91,1.39,9.69,1.8,9.69,1.8Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Socket--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,283.51c7.21-2,8.72-7.89,3.37-13.12s-15.52-7.85-22.73-5.84-8.72,7.89-3.37,13.12S267.74,285.52,275,283.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,273.17l2.6.67a8.25,8.25,0,0,1,4.2-2.46c5.86-1.64,14.13.49,18.48,4.75a8.29,8.29,0,0,1,2.5,4.17l2.6.67-4.21,4h0a9,9,0,0,1-3.62,1.87c-5.86,1.64-14.13-.49-18.48-4.75a8.9,8.9,0,0,1-2.28-3.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.48,280.67c10.65-3,12.85-11.69,4.93-19.41s-23-11.55-33.63-8.55-12.86,11.7-4.93,19.42S270.83,283.68,281.48,280.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.02,
    cy: 263.19,
    rx: 14.69,
    ry: 25.45,
    transform: "translate(-53.05 458.17) rotate(-75.75)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.23,274.29c11.33-3.19,13.68-12.44,5.25-20.65s-24.44-12.27-35.77-9.08S240,257,248.47,265.21,272.91,277.49,284.23,274.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.93,
    cy: 255.66,
    rx: 15.44,
    ry: 26.74,
    transform: "translate(-44.31 454.35) rotate(-75.75)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,267.5c11.88-3.35,14.34-13.05,5.5-21.67S266.75,233,254.87,236.3s-14.35,13-5.5,21.67S275,270.85,286.9,267.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,264.11c12.16-3.43,14.68-13.36,5.63-22.18s-26.25-13.19-38.41-9.76-14.68,13.36-5.63,22.18S276.07,267.54,288.23,264.11Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247,226.88c1.07-4.19,4.91-7.68,11.27-9.47,12.73-3.59,30.73,1,40.2,10.21,4.74,4.61,6.44,9.51,5.38,13.71-.42,1.63-2,8-2.46,9.67-1.07,4.19-4.91,7.69-11.28,9.48-12.74,3.58-30.74-1-40.2-10.21-4.74-4.62-6.44-9.52-5.37-13.72C245,234.92,246.57,228.52,247,226.88Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.69,40.06a88.19,88.19,0,0,1,63.77,107.19c-17.23,67.87-76.09,64.91-83,92.26-1.11,4.36-5.1,8-11.7,9.85-13.21,3.73-31.88-1-41.71-10.59-4.91-4.79-6.68-9.88-5.58-14.24h0c6.95-27.35-46.18-52.84-28.95-120.7A88.2,88.2,0,0,1,324.69,40.06Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.69,40.06a88.19,88.19,0,0,1,63.77,107.19c-17.23,67.87-76.09,64.91-83,92.26-1.11,4.36-5.1,8-11.7,9.85-13.21,3.73-31.88-1-41.71-10.59-4.91-4.79-6.68-9.88-5.58-14.24h0c6.95-27.35-46.18-52.84-28.95-120.7A88.2,88.2,0,0,1,324.69,40.06Z",
    style: {
      fill: "#fff",
      mixBlendMode: "screen",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.9,
    cy: 232.17,
    rx: 14.69,
    ry: 25.45,
    transform: "translate(-17.05 442.43) rotate(-75.75)",
    style: {
      fill: "#9D7600",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,233.57a19,19,0,0,0,3.35,4.25c8.22,8,23.84,12,34.88,8.86a18.91,18.91,0,0,0,5-2.14,18.9,18.9,0,0,0-3.34-4.24c-8.23-8-23.85-12-34.89-8.86A18.58,18.58,0,0,0,252.55,233.57Z",
    style: {
      fill: "#9D7600",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,233.57a19,19,0,0,0,3.35,4.25c8.22,8,23.84,12,34.88,8.86a18.91,18.91,0,0,0,5-2.14,18.9,18.9,0,0,0-3.34-4.24c-8.23-8-23.85-12-34.89-8.86A18.58,18.58,0,0,0,252.55,233.57Z",
    style: {
      fill: "#9D7600",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.43,63.52A13.63,13.63,0,0,1,275,66.07c2.73,3.52,2.91,8.59,1.2,12.7-3.31,8-12.58,11.09-18.82,16.35a75.91,75.91,0,0,0-17.07,20.48c-1.31,2.32-3.25,6.22-5.1,8.14a6.88,6.88,0,0,1-9.23.7c-2.87-2.61-3.54-7.2-3.18-10.57,2.14-20.05,9.77-33.52,23.3-45.92C253.45,61.19,263.51,56.68,272.43,63.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.11,
    cy: 109.31,
    r: 62.9,
    transform: "translate(12.66 249.18) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,137.58a9.68,9.68,0,0,1-2.84,7.43,5.65,5.65,0,0,1-7.93-.19,9.11,9.11,0,0,1-2.19-8.44c.85-3.12,3.72-5.95,7.29-5.41C231.66,131.47,233.81,134.73,234,137.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.24,227.72c4.65-10.35,9.09-15.41,24.16-18.86s40.8-8,57.57-33.4c-23.72,39.49-65.74,41.21-71.54,64-1.11,4.36-5.1,8-11.7,9.85A35.74,35.74,0,0,1,285,250.6Z",
    style: {
      fill: "#9D7600",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,219c.85-11.31-.63-17.88-12.24-28.11s-32-26.48-34.65-56.82c2,46,38.11,67.59,32.31,90.43-1.11,4.36.67,9.45,5.58,14.24a36.14,36.14,0,0,0,7.1,5.26C259.67,236.87,260.49,226.07,261,219Z",
    style: {
      fill: "#9D7600",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,152.74c1.39,4.08,6.74,8.76,17.59,9.66.72.07,1.49.1,2.27.1A59.38,59.38,0,0,1,273,173.24c.53,15.11-2.52,34.45-10.2,64.68l-.25,1,3,.75.25-1c7.75-30.52,10.83-50.12,10.3-65.54a64.81,64.81,0,0,0-1.23-10.75,56.48,56.48,0,0,0,20.36-6,56,56,0,0,0,15,15,65.83,65.83,0,0,0-6.21,8.87c-7.82,13.29-14.47,32-22.22,62.51l-.26,1,3,.75.25-1c7.67-30.22,14.22-48.68,21.9-61.71a59.31,59.31,0,0,1,6.25-8.81c.69.37,1.38.7,2.05,1,10,4.38,16.9,2.82,20.07-.1a7.66,7.66,0,0,0,2-8.48c-1-2.89-3.55-4.73-7-5.08-5.43-.54-11.85,2.64-17.71,8.75a52.29,52.29,0,0,1-14.46-14.22,23,23,0,0,0,3-2.23c6.79-6.19,8.11-12.79,7.07-16.9a8.08,8.08,0,0,0-13.95-3.55C291,135.28,289,141.71,292,150.4a22.5,22.5,0,0,0,1.53,3.36,52.05,52.05,0,0,1-19.48,5.6c-2.25-8.16-6.37-14-11.39-16.14-3.19-1.33-6.31-.92-8.56,1.14A7.64,7.64,0,0,0,251.81,152.74ZM315,170.64c5-5,10.42-7.7,14.62-7.28a8.67,8.67,0,0,1,1.06.18,4.53,4.53,0,0,1,3.33,2.85,4.59,4.59,0,0,1-1.14,5.22c-2.45,2.27-8.15,3.34-16.76-.45C315.79,171,315.42,170.83,315,170.64Zm-20.11-21.25c-2.12-6.1-1.65-12,1.2-15.15a5,5,0,0,1,8.73,2.21c1,4.09-1.4,9.54-6.17,13.9a19.27,19.27,0,0,1-2.48,1.88A19.42,19.42,0,0,1,294.93,149.39Zm-38.73-2.77a4.8,4.8,0,0,1,5.3-.57c3.89,1.63,7.34,6.59,9.38,13.37-.42,0-.83,0-1.23-.07-9.37-.78-13.87-4.44-14.94-7.6A4.59,4.59,0,0,1,256.2,146.62Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.18,138.91a2.67,2.67,0,0,0-1.62-.1,2.76,2.76,0,0,0-.09-.27,2.13,2.13,0,0,0-1.23-1.11,3.14,3.14,0,0,0-1.43-.07,11,11,0,0,0-2.35.86c-.7.31-1.4.64-2.09,1a47.3,47.3,0,0,1-4.57,2,20.07,20.07,0,0,1-5.71,1.41,3.2,3.2,0,0,1-1.71-.27,4.57,4.57,0,0,1,1.94-1.48c1.37-.75,3.55-2.1,4-3.75a2.55,2.55,0,0,0-.2-1.38,1.59,1.59,0,0,0-.37-.66c-.58-.49-2.65.71-3.28.95-1.21.46-2.41.93-3.61,1.43a64.39,64.39,0,0,0-6.88,3.24c-1.75,1-3.45,2.18-5.5,2.09-1.29-.05-2.58-.18-3.87-.33-3.21-.38-6.4-.9-9.59-1.46-4.18-.74-12.45-2.92-16.6-3.81,0,0-8.32-19.88-11.81-28.87-3-7.77-7.06-15-12.92-16.82-9.29,4.47-10.17,16.86-2.19,35.56,6.08,14.17,6.25,15.25,9.27,21.52,3.77,7.85,4.52,7.84,14.05,8.7s29.44.52,35.85.83a53.5,53.5,0,0,0,13.79-.65v0a31.53,31.53,0,0,0,4.28-1c.73-.23,1.45-.48,2.17-.75a36.5,36.5,0,0,0,5.25-2.23,14.65,14.65,0,0,0,2-1.76,5.69,5.69,0,0,0,1.56-2.4,2.05,2.05,0,0,0,0-1.11,9.58,9.58,0,0,0,2.37-3.7,2,2,0,0,0-.19-1.48s.45-.41.81-.76a9.35,9.35,0,0,0,1.58-1.72C232.61,140,231.71,139.1,231.18,138.91Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3,147.33c1.39-.58,2.8-1.09,4.2-1.63.69-.27,1.39-.54,2.06-.83a12.62,12.62,0,0,0,1.9-1.1c1.25-.81,2.47-1.67,3.69-2.53.61-.43,1.2-.89,1.77-1.36a1.17,1.17,0,0,0,.56-.85,1.32,1.32,0,0,0-.36-1,1.33,1.33,0,0,1,.51,1,1.19,1.19,0,0,1-.15.58,3.38,3.38,0,0,1-.37.46,18.58,18.58,0,0,1-1.68,1.52,39.55,39.55,0,0,1-3.62,2.7,10.58,10.58,0,0,1-2,1.14c-.71.3-1.42.53-2.14.76C218.23,146.63,216.78,147,215.3,147.33Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,143a30.33,30.33,0,0,1-2.8,3.3,11.43,11.43,0,0,1-1.69,1.4,9.38,9.38,0,0,1-2,1c-1.35.51-2.72,1-4.1,1.34s-2.77.77-4.18,1.06c1.34-.53,2.69-1,4-1.51s2.7-1,4-1.49a10.46,10.46,0,0,0,3.55-2.16C227.77,145,228.77,144,229.85,143Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,148.17a9.54,9.54,0,0,1-2,2.18,9.93,9.93,0,0,1-2.6,1.45c-.91.36-1.82.68-2.75,1s-1.86.56-2.81.79c1.74-.87,3.54-1.61,5.32-2.34a15.43,15.43,0,0,0,2.52-1.31A24.81,24.81,0,0,0,227.67,148.17Z",
    style: {
      fill: "#f0997a"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--symbol--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.15,209.54c-2.28-7.92-7.38-12.72-14.17-13.77l0,0c-5.49-.86-12.09.74-19.21,5.11-19.32,11.91-35.1,39.82-35.24,62.36-.05,8.06,1.9,14.32,5.31,18.53,3.94,4.85,9.82,6.92,16.82,5.77-6.27,3.27-12.19,4.85-17.52,4.91l-1.7,2.92L337.28,289l0,0c-7.51-4.83-12.12-14.47-12.12-28,0-28.14,19.92-62.36,44.49-76.43,11.81-6.77,22.55-7.66,30.53-3.62l11.13,6.38-1.7,2.92C412.47,195.19,414.1,201.7,414.15,209.54Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.15,209.54c-2.28-7.92-7.38-12.72-14.17-13.77l0,0c-5.49-.86-12.09.74-19.21,5.11-19.32,11.91-35.1,39.82-35.24,62.36-.05,8.06,1.9,14.32,5.31,18.53,3.94,4.85,9.82,6.92,16.82,5.77-6.27,3.27-12.19,4.85-17.52,4.91l-1.7,2.92L337.28,289l0,0c-7.51-4.83-12.12-14.47-12.12-28,0-28.14,19.92-62.36,44.49-76.43,11.81-6.77,22.55-7.66,30.53-3.62l11.13,6.38-1.7,2.92C412.47,195.19,414.1,201.7,414.15,209.54Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.64,287.52c-6.27,3.27-12.19,4.85-17.52,4.91l-1.7,2.92L337.28,289l0,0c-7.51-4.83-12.12-14.47-12.12-28,0-14.07,5-29.66,13-43.5l17.93,10.27c-6.5,11.37-10.55,24.13-10.63,35.51-.05,8.06,1.9,14.32,5.31,18.53C354.76,286.6,360.64,288.67,367.64,287.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.64,287.52c-6.27,3.27-12.19,4.85-17.52,4.91l-1.7,2.92L337.28,289l0,0c-7.51-4.83-12.12-14.47-12.12-28a67.89,67.89,0,0,1,.95-11.05L345.57,261c0,.75-.06,1.48-.06,2.21-.05,8.06,1.9,14.32,5.31,18.53C354.76,286.6,360.64,288.67,367.64,287.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.06,187.11c-8-4.45-19-3.71-31.19,3.24a68.33,68.33,0,0,0-8.15,5.52c-.28.22-.55.43-.81.66h0c-.07.06-.14.1-.21.17l-10.2-5.84a68.21,68.21,0,0,1,9.18-6.35c11.81-6.77,22.55-7.66,30.53-3.62Z",
    style: {
      fill: "#9D7600",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78,203.25h0c-5.17-18.64-22.42-24.62-42.91-12.89a68.33,68.33,0,0,0-8.15,5.52c-.28.22-.55.43-.81.66h0c-20.27,16.36-35.52,45.63-35.52,70.26,0,28.13,19.92,39.54,44.49,25.47s44.49-48.29,44.49-76.43A47,47,0,0,0,422.78,203.25Zm-42.55,79.23c-12.43,7.65-23.28,6.82-29.41-.73-3.41-4.21-5.36-10.47-5.31-18.53.14-22.54,15.92-50.45,35.24-62.36,7.12-4.37,13.72-6,19.21-5.11l0,0c9.42,1.46,15.59,10.12,15.49,24.34C415.33,242.65,399.55,270.57,380.23,282.48Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78,203.23c-.13-.37-3.68-12.25-16.12-16.76-11.9-4.32-29.74,5.48-34.94,9.4a68.33,68.33,0,0,1,8.15-5.52C400.36,178.62,417.61,184.6,422.78,203.23Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,279.38c.12.37,3.68,12.25,16.12,16.77,11.9,4.32,29.74-5.49,34.94-9.41a69.14,69.14,0,0,1-8.15,5.52C359.38,304,342.12,298,337,279.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.47,220.11c-.14,22.54-15.92,50.46-35.24,62.37-12.43,7.65-23.28,6.82-29.41-.73,5.49.85,12.09-.76,19.2-5.13,19.32-11.91,35.1-39.83,35.25-62.37,0-8-1.89-14.29-5.29-18.48C409.4,197.23,415.57,205.88,415.47,220.11Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.47,220.11c-.14,22.54-15.92,50.46-35.24,62.37-12.43,7.65-23.28,6.82-29.41-.73,5.49.85,12.09-.76,19.2-5.13,19.32-11.91,35.1-39.83,35.25-62.37,0-8-1.89-14.29-5.29-18.48C409.4,197.23,415.57,205.88,415.47,220.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,194c-22.85,13.08-41.36,44.89-41.36,71.05s18.51,36.76,41.36,23.68,41.36-44.89,41.36-71.05S402.74,180.91,379.9,194Zm.33,88.49c-12.43,7.65-23.28,6.82-29.41-.73-3.41-4.21-5.36-10.47-5.31-18.53.14-22.54,15.92-50.45,35.24-62.36,7.12-4.37,13.72-6,19.21-5.11l0,0c9.42,1.46,15.59,10.12,15.49,24.34C415.33,242.65,399.55,270.57,380.23,282.48Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,194c-22.85,13.08-41.36,44.89-41.36,71.05s18.51,36.76,41.36,23.68,41.36-44.89,41.36-71.05S402.74,180.91,379.9,194Zm.33,88.49c-12.43,7.65-23.28,6.82-29.41-.73-3.41-4.21-5.36-10.47-5.31-18.53.14-22.54,15.92-50.45,35.24-62.36,7.12-4.37,13.72-6,19.21-5.11l0,0c9.42,1.46,15.59,10.12,15.49,24.34C415.33,242.65,399.55,270.57,380.23,282.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.26,217.45c0,1.08,0,2.15-.09,3.25-1.24-2.25-3.06-3.67-5.72-2.56-.5-13.81-7.2-21.91-17.05-22.57,1.32-2.42,1.83-4.92.68-7.18,9.88.27,17.41,6.34,20.57,17a41.07,41.07,0,0,1,1.28,6.41A50,50,0,0,1,421.26,217.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,205a5.39,5.39,0,0,1-3.54,2.17c-2-5.15-5.39-8.7-9.72-10.43a8,8,0,0,1,1.43-5c2.42-3.25,7-2.91,10.29.76S419.3,201.76,416.89,205Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,288.59a49.35,49.35,0,0,1-5,2.52c-1.14.51-2.26.95-3.37,1.33-16.28,5.59-29.13-1.74-32.38-18.55-.22-1.13-.4-2.32-.54-3.56-.17-1.64-.26-3.34-.27-5.12s.07-3.44.22-5.19c.11-1.39.29-2.82.49-4.23s.47-2.83.78-4.25a82.94,82.94,0,0,1,3.81-12.77c.35-.92.72-1.84,1.1-2.74a98.9,98.9,0,0,1,14.93-24.67c-.09.29-1.56,5,1.83,7.73-9.67,13.2-16.12,29.76-16.21,44.13-.05,8.06,1.9,14.32,5.31,18.53,5.26,6.47,14,8,24.23,3.46A5.79,5.79,0,0,0,380.08,288.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.61 197.14 416.06 199.76 412.15 198.01 407.49 204.67 410.98 197.51 407.49 194.85 411.48 196.49 416.06 189.94 412.61 197.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.45,245.58A21.88,21.88,0,0,1,379,251.4a9,9,0,0,1-1.56.72,14.81,14.81,0,0,1-.55-4.18c0-7.31,4.31-15.68,9.6-18.73a13.19,13.19,0,0,1,6.57-1.7l4.21-14.06-7.49-4.32c-.29-.23-4.51-2-12.83,2.83-11.07,6.4-21.36,24.61-21.36,39.9,0,7.95,2.88,13.39,7.24,15.81,1.22.67,6.13,3.55,7.42,4.28,3.88,2.19,8.94,2,14.18-1.06a47.07,47.07,0,0,0,12.84-11.72c-1.47-3.33-2.84-5.94-4.31-9.27Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,227.51l4.21-14.06c-.3-.22-4.51-2-12.84,2.84-11.07,6.39-21.35,24.61-21.35,39.89,0,15,10.28,21.1,21.35,14.71a47.07,47.07,0,0,0,12.84-11.72c-1.47-3.33-2.84-5.94-4.31-9.27a21.72,21.72,0,0,1-6.47,5.83c-5.29,3-9.6-.21-9.6-7.79,0-7.31,4.31-15.68,9.6-18.73A13.19,13.19,0,0,1,393,227.51Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,227.51l4.21-14.06c-.3-.22-4.51-2-12.84,2.84-11.07,6.39-21.35,24.61-21.35,39.89,0,15,10.28,21.1,21.35,14.71a47.07,47.07,0,0,0,12.84-11.72c-1.47-3.33-2.84-5.94-4.31-9.27a21.72,21.72,0,0,1-6.47,5.83c-5.29,3-9.6-.21-9.6-7.79,0-7.31,4.31-15.68,9.6-18.73A13.19,13.19,0,0,1,393,227.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.07,268.12c-9.35-14.62,4-43.14,17.34-51.83-11.07,6.39-21.35,24.61-21.35,39.89,0,15,10.28,21.1,21.35,14.71h0C378.56,274,371,274,367.07,268.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.38,103.42,96.14,107c-2.81,2.54-2.81-14.9,0-17.43l13.77-2.34a2.1,2.1,0,0,1,1.24.23c1.1.6,5,2.9,5.34,3.09a2.11,2.11,0,0,1,.56,3.27l-15.57,16.26C100.09,111.31,99.39,107.7,99.38,103.42Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,103.42,96.14,107c-2.81,2.54-2.81-14.9,0-17.43l13.77-2.34a2.1,2.1,0,0,1,1.24.23c1.1.6,5,2.9,5.34,3.09a2.11,2.11,0,0,1,.56,3.27l-15.57,16.26C100.09,111.31,99.39,107.7,99.38,103.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,103.42,96.14,107c-2.81,2.54-2.81-14.9,0-17.43l13.77-2.34a2.1,2.1,0,0,1,1.24.23c1.1.6,5,2.9,5.34,3.09a2.11,2.11,0,0,1,.56,3.27l-15.57,16.26C100.09,111.31,99.39,107.7,99.38,103.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,149.11l0-53.56a4.26,4.26,0,0,1,1.94-3.36l47.6-27.51a4.26,4.26,0,0,1,3.87,0l3.52,2.07a4.37,4.37,0,0,1,1.93,3.38l0,53.57a4.29,4.29,0,0,1-1.94,3.36L54,154.58a4.23,4.23,0,0,1-3.87,0l-3.51-2.07A4.33,4.33,0,0,1,44.7,149.11Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,149.11l0-53.56a4.26,4.26,0,0,1,1.94-3.36l47.6-27.51a4.26,4.26,0,0,1,3.87,0l3.52,2.07a4.37,4.37,0,0,1,1.93,3.38l0,53.57a4.29,4.29,0,0,1-1.94,3.36L54,154.58a4.23,4.23,0,0,1-3.87,0l-3.51-2.07A4.33,4.33,0,0,1,44.7,149.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.51,69.85c-.14-1-.94-1.38-1.92-.81L54,96.54a3.8,3.8,0,0,0-1.28,1.3L45.3,93.56a3.84,3.84,0,0,1,1.31-1.37l47.61-27.5a4.23,4.23,0,0,1,3.87,0l3.51,2.07A4.38,4.38,0,0,1,103.51,69.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,153.46l0-53.56A4.27,4.27,0,0,1,54,96.54L101.6,69c1.07-.62,1.94-.11,1.94,1.12V92.4l11.71-2.1a2.1,2.1,0,0,1,1.8,3.5l-13.49,14.09v15.83a4.29,4.29,0,0,1-1.94,3.36L54,154.58C52.94,155.2,52.07,154.7,52.07,153.46Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,153.46l0-53.56A4.27,4.27,0,0,1,54,96.54L101.6,69c1.07-.62,1.94-.11,1.94,1.12V92.4l11.71-2.1a2.1,2.1,0,0,1,1.8,3.5l-13.49,14.09v15.83a4.29,4.29,0,0,1-1.94,3.36L54,154.58C52.94,155.2,52.07,154.7,52.07,153.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,100.4l-1.56.9V94.51c0-5-3.07-7.36-6.85-5.18s-6.85,8-6.85,13.09v6.78l-1.56.9a5.94,5.94,0,0,0-2.47,4.72v18.71c0,1.53.8,2.4,1.92,2.1,5.89-1.59,12-5.13,17.92-10.35a5.77,5.77,0,0,0,1.38-2,5.87,5.87,0,0,0,.54-2.35V102.26C88.55,100.45,87.44,99.61,86.08,100.4Zm-6.22,23.15-4.38,2.53.77-6.94c-.77-.2-1.29-1-1.29-2.33a6.47,6.47,0,0,1,2.71-5.18c1.5-.87,2.71.05,2.71,2.05a6.89,6.89,0,0,1-1.29,3.81Zm1.85-20.63-8.08,4.66V100.8c0-3,1.81-6.43,4-7.72s4,.09,4,3Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.51,132.55l-41.51-24c-.68-.39-1.22-.07-1.22.71V154a2.66,2.66,0,0,0,1.22,2.11l41.51,24c.67.39,1.22.07,1.22-.71V134.67A2.69,2.69,0,0,0,465.51,132.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.15,113.36l36.43,21a3,3,0,0,1,1.35,2.33v42.36a3,3,0,0,1-1.35,2.31L459,182.82a3,3,0,0,1-2.69,0l-36.44-21a3,3,0,0,1-1.34-2.33V117.11a2.91,2.91,0,0,1,1.35-2.31l2.56-1.46A3,3,0,0,1,425.15,113.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,182.81a3.08,3.08,0,0,0,2.7,0l2.56-1.46a3,3,0,0,0,1.35-2.31V136.7a2.75,2.75,0,0,0-.43-1.37l-5.24,3a2.63,2.63,0,0,1,.4,1.32V182C457.66,182.82,457.11,183.27,456.32,182.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,116.34l36.44,21a3,3,0,0,1,1.34,2.33V182c0,.86-.6,1.21-1.34.78l-36.44-21a3,3,0,0,1-1.34-2.33V117.11C418.54,116.25,419.14,115.91,419.88,116.34Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--symbol--inject-2",
    d: "M439,132.36c-3.34-1.92-6.64-2.14-9.3-.61-3.09,1.79-4.86,5.74-4.86,10.85,0,9.19,5.45,19.54,12.41,23.56a11,11,0,0,0,5.46,1.62,7.55,7.55,0,0,0,3.84-1c3.09-1.78,4.86-5.74,4.86-10.85C451.38,146.73,445.93,136.38,439,132.36Zm0,30.77c-5.88-3.39-10.66-12.6-10.66-20.53a12,12,0,0,1,1.26-5.85l14.32,27.36A6.58,6.58,0,0,1,439,163.13Zm7.65-1.35L432.3,134.42a4.24,4.24,0,0,1,1.22-.18,7.69,7.69,0,0,1,3.7,1.15c5.88,3.4,10.66,12.61,10.66,20.53A12,12,0,0,1,446.62,161.78Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M465.51,59.54,424,35.58c-.68-.39-1.22-.08-1.22.7V81A2.69,2.69,0,0,0,424,83.11l41.51,24c.67.39,1.22.07,1.22-.7V61.65A2.67,2.67,0,0,0,465.51,59.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.15,40.34l36.43,21a2.94,2.94,0,0,1,1.35,2.32V106a2.93,2.93,0,0,1-1.35,2.31L459,109.81a3,3,0,0,1-2.69,0l-36.44-21a3,3,0,0,1-1.34-2.33V44.1a2.93,2.93,0,0,1,1.35-2.32l2.56-1.45A3,3,0,0,1,425.15,40.34Z",
    style: {
      fill: "#9D7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,109.79a3.08,3.08,0,0,0,2.7,0l2.56-1.46a2.93,2.93,0,0,0,1.35-2.31V63.68a2.81,2.81,0,0,0-.43-1.37l-5.24,3a2.69,2.69,0,0,1,.4,1.32V109C457.66,109.8,457.11,110.25,456.32,109.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.55,43.85c.11-.68.66-.92,1.33-.53l36.43,21a2.62,2.62,0,0,1,.95,1l5.25-3a2.86,2.86,0,0,0-.93-1l-36.43-21a3,3,0,0,0-2.7,0l-2.56,1.46A3,3,0,0,0,418.55,43.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,43.32l36.44,21a3,3,0,0,1,1.34,2.32V109c0,.86-.6,1.2-1.34.77l-36.44-21a3,3,0,0,1-1.34-2.33V44.1C418.54,43.24,419.14,42.89,419.88,43.32Z",
    style: {
      fill: "#9D7600"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.84,87.58a2,2,0,0,1-.34,0,2.56,2.56,0,0,1-2-1.46l-4.16-8.76a2.59,2.59,0,0,1,4.68-2.2l2.46,5.14,11.89-13.83a2.59,2.59,0,1,1,3.93,3.37L435.81,86.68A2.63,2.63,0,0,1,433.84,87.58Z",
    style: {
      fill: "#fafafa"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatentProtection);
export default __webpack_public_path__ + "static/media/patent-protection.ac9f63fde0b731b0c1bf0db7cb783ea3.svg";
export { ForwardRef as ReactComponent };